import { render, staticRenderFns } from "./DeleteSupplier.vue?vue&type=template&id=a06e57b2&scoped=true"
import script from "./DeleteSupplier.vue?vue&type=script&lang=js"
export * from "./DeleteSupplier.vue?vue&type=script&lang=js"
import style0 from "./DeleteSupplier.vue?vue&type=style&index=0&id=a06e57b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06e57b2",
  null
  
)

export default component.exports